// Copyright Epic Games, Inc. All Rights Reserved.

import { Grid } from "@material-ui/core";
import styled from "styled-components";

export const FullPageGrid = styled(Grid)({
  // We need to remove the AppBar height from the main body page.
  height: "calc(100vh - 30px)",
  width: "100vw",
  margin: 0,
});
